import {
  ControlButton,
  ControlButtonProps,
} from '../../../components/Controls/ControlButton';

export type TileNodeControlButtonProps = ControlButtonProps;

export const TileNodeControlButton = (props: TileNodeControlButtonProps) => {
  return <ControlButton size="xs" variant="secondary" {...props} />;
};
